import { render, staticRenderFns } from "./Okyanus.vue?vue&type=template&id=79bad0e4"
import script from "./Okyanus.vue?vue&type=script&lang=js"
export * from "./Okyanus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports